/**
 * Enum for differentiating the types of destinations based on their purpose and protocol.
 */
export enum ComponentType {
  Email = 'EmailDestination', // Destinations that initiate an email client via 'mailto'.
  External = 'ExternalDestination', // Destinations that point to external websites, requiring potentially different security or behavior.
  Internal = 'InternalDestination', // Destinations that point to a destination within the same web application.
  Telephone = 'PhoneDestination', // Destinations that initiate a telephone call via 'tel'.
  Interactive = 'Interactive', // Represents a standard button element. Destinations that act as buttons, triggering interactive behavior rather than navigation.
  Fake = 'FakeInteractive', // Represents a button-like element styled as a destination or a custom interaction. Destinations that look like destinations but do not perform traditional navigation, used for custom interactions.
  Input = 'InputInteractive', // Represents an input-trigger button, e.g., for opening input modals. Buttons that act as input triggers, such as opening a search or input modal.
  Link = 'Destination', // Represents a button used as a destination for navigation.
  Anchor = 'AnchorPattern',
  Breadcrumb = 'BreadcrumbPattern',
  DynamicRoute = 'DynamicRouteDestination',
  Redirect = 'RedirectPattern',
}
